import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { User } from '../../../shared/models/user.model';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';
import { AppHttpService } from '../../../shared/services/app-http.service';
import { MessageType } from '../../../shared/enums/message-type.enum';
import { environment } from '../../../../environments/environment';
import { BaseFormComponent } from '../../../shared/class/base-form.class';
import { BaseTableComponent } from '../../../shared/class/base-table-component.class';
import { Pagination } from '../../../shared/models/table.model';

@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.scss']
})
export class ListUserComponent extends BaseTableComponent implements OnInit {
  usersList: User[] = [];
  userIdToDelete: number | null = null;

  public appBaseUrl = environment.API_URL;

  constructor(private confirmationService: ConfirmationService) {
    super();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.route.queryParamMap.subscribe(param => {
        this.updateQueryParam(param);
        this.getUserRecords(param);
      })
    );
  }

  async getUserRecords(filterPayload: any | undefined) {
    let pagination: Pagination = {
      limit: this.perPage,
      skip: this.currentPage * this.perPage,
      take: this.perPage,
      order: {
        createdAt: 'DESC',
      }
    };

    filterPayload = {
      limit: pagination.limit,
      skip: pagination.skip,
      take: pagination.take,
      order: pagination.order,
      ...filterPayload.params
    }
    let response: ApiResponse<any> = await this.httpService.httpRequest<User>(
      "user",
      "find-all-and-count-by-admin",
      filterPayload
    );

    if (response.status && response.data) {
      this.usersList = response.data![0] ?? [];
      this.totalRecords = response.data?.[1] ?? 0;
    }
  }

  onPageChange(page: any) {
    this.currentPage = Math.round(page.first / page.rows);
    this.perPage = page.rows;

    const payload = {
      pageIndex: this.currentPage,
      pageSize: this.perPage
    }
    this.onPageEvent(payload, '/settings/users');
  }

  // Confirmation for delete
  confirmDelete(userId: number, event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Do you want to delete this User?',
      icon: 'pi pi-info-circle',
      acceptButtonStyleClass: 'p-button-danger p-button',
      accept: () => {
        this.userIdToDelete = userId;
        this.deleteUser();
      },
      reject: () => {
        this.notificationService.notify('User Deletion Cancelled', MessageType.Error)
      }
    });
  }

  async deleteUser() {
    if (this.userIdToDelete) {
      const payload = {
        id: this.userIdToDelete
      };

      let response: ApiResponse<any> = await this.httpService.httpRequest<User>(
        "user",
        "delete",
        payload
      );

      if (response.status && response.data) {
        location.reload();
        this.notificationService.notify('User Deleted Successfully', MessageType.Success)
      } else{
        this.notificationService.notify('Unable to Delete User', MessageType.Error)
      }
      this.userIdToDelete = null;
    }
  }


}
